import StreamProcessService from './StreamProcessService';
import { appDebugLog } from '../Util/appDebugLog';

const LogTitle = 'StreamProcessManagerService';

class StreamProcessManagerService {
    private _streamProcessMap: Record<string, StreamProcessService> = {}; // Define the type for _streamProcessMap.
  
    startConnection(callRecordId: string, twilioCall?: any): void { // twilioCall: same Call as accept; avoids static race
      const streamProcess = new StreamProcessService(callRecordId, twilioCall);
      this._streamProcessMap[callRecordId] = streamProcess;
  
      streamProcess.start();
    }
  
    stopConnection(callRecordId?: string): void { // Make callRecordId optional and specify the return type.
      if (!callRecordId) {
        appDebugLog('CallRecordId is not given. Skipping removing socket mapping');
        return;
      }
  
      const streamProcess = this._streamProcessMap[callRecordId];
  
      if (streamProcess) {
        streamProcess.stop();
        delete this._streamProcessMap[callRecordId];
      }
    }
  
    setStreamMuteState(callRecordId: string, muted: boolean = true): void { // Specify the types for parameters and the return type.
      const streamProcess = this._streamProcessMap[callRecordId];
  
      if (streamProcess) {
        if (muted) {
          streamProcess.muteStreams();
        } else {
          streamProcess.unmuteStreams();
        }
      }
    }
  
    receiveCallHoldUpdate(callRecordId: string, isHold: boolean): void { // Specify the types for parameters and the return type.
      const streamProcess = this._streamProcessMap[callRecordId];
  
      if (streamProcess) {
        streamProcess.didReceiveCallHoldUpdate(callRecordId, isHold);
      }
    }

    /** Twilio Call `reconnected` — rebind mic/phone recording graph to fresh MediaStreamTracks. */
    reattachMediaAfterTwilioReconnect(callRecordId?: string, reason: string = 'twilio_reconnected'): void {
      if (!callRecordId) {
        return;
      }
      const streamProcess = this._streamProcessMap[callRecordId];
      if (streamProcess) {
        streamProcess.reattachMediaAfterTwilioReconnect(reason);
      }
    }
  
    createManualBookmark(callRecordId: string, startTime: number, endTime: number): void { // Specify the types for parameters and the return type.
      const streamProcess = this._streamProcessMap[callRecordId];
      if (streamProcess) {
        streamProcess.createManualBookmark(startTime, endTime);
      }
    }
  }
  
  export default StreamProcessManagerService;